import React, { Suspense } from "react";
import { Helmet } from "react-helmet-async";
import Card from "@mui/material/Card";

// Presentation page sections
const Counter = React.lazy(() => import("pages/Homepage/sections/Counter"));
const InformationHome = React.lazy(() => import("pages/Homepage/sections/InformationHome"));
const TestimonialsHome = React.lazy(() => import("pages/Homepage/sections/TestimonialsHome"));
const FAQSection = React.lazy(() => import("pages/Homepage/sections/FAQSection"));
const HeroSection = React.lazy(() => import("pages/Homepage/sections/HeroSection"));
// const BreakPointSection = React.lazy(() => import("pages/Homepage/sections/BreakPointSection"));
const ServicesSection = React.lazy(() => import("pages/Homepage/sections/Services"));
const StepsSection = React.lazy(() => import("pages/Homepage/sections/StepsSections"));
// const BlogsSection = React.lazy(() => import("pages/Homepage/sections/BlogsSections")); momentan ramane ascunsa pana apar alte modificari
// const BeforeAfterGallery = React.lazy(() => import("pages/Homepage/sections/BeforeAfterGallery"));

const localBusinessSchema = {
    "@context": "https://schema.org",
    "@type": "LocalBusiness",
    "@id": "https://doral-cleaning.ro/#business",
    name: "Doral Cleaning - Servicii profesionale de curatenie",
    url: "https://doral-cleaning.ro/",
    telephone: "0730 407 322",
    foundingDate: "2006",
    address: {
        "@type": "PostalAddress",
        streetAddress: "Calea Șerban Vodă 82, Sector 4",
        addressLocality: "București",
        postalCode: "040213",
        addressCountry: "RO",
    },
    geo: {
        "@type": "GeoCoordinates",
        latitude: 44.4202372718721,
        longitude: 26.10209372955662,
    },
    areaServed: [
        { "@type": "City", name: "București" },
        { "@type": "AdministrativeArea", name: "Județul Ilfov" },
        { "@type": "City", name: "Voluntari" },
        { "@type": "City", name: "Pantelimon" },
        { "@type": "City", name: "Popești-Leordeni" },
        { "@type": "City", name: "Bragadiru" },
        { "@type": "City", name: "Măgurele" },
        { "@type": "City", name: "Chitila" },
        { "@type": "City", name: "Buftea" },
        { "@type": "City", name: "Otopeni" },
    ],
};

function Homepage() {
    return (
        <Suspense fallback={<div>Loading...</div>}>
            <Helmet>
                <title>Firmă de Curățenie Birouri și Hale | Doral Cleaning</title>
                <link rel="canonical" href="https://doral-cleaning.ro/" />
                <meta
                    name="description"
                    content="Firmă de curățenie din Sectorul 4, București, din 2006: birouri, hale, depozite și post-construct în toate sectoarele și în Ilfov. Cere o ofertă."
                />
                <script type="application/ld+json">{JSON.stringify(localBusinessSchema)}</script>
            </Helmet>
            <HeroSection />
            <Card
                sx={{
                    p: 2,
                    mx: { xs: 2, lg: 3 },
                    mt: -8,
                    mb: 4,
                    backgroundColor: ({ palette: { white }, functions: { rgba } }) =>
                        rgba(white.main, 0.8),
                    backdropFilter: "saturate(200%) blur(30px)",
                    boxShadow: ({ boxShadows: { xxl } }) => xxl,
                }}
            >
                <Counter />
                <TestimonialsHome />
                {/* <BreakPointSection /> */}
                <InformationHome />
                <ServicesSection />
                <StepsSection />
                {/* <BeforeAfterGallery /> */}
                {/* <BlogsSection /> */}
                <FAQSection />
            </Card>
        </Suspense>
    );
}

export default Homepage;
